export type IconProps = {
  color?: string;
  size?: string | number;
} & React.SVGAttributes<SVGElement>;

export enum UserStatusEnum {
  'NOT STARTED' = 'NOT_STARTED',
  'DRAFT' = 'DRAFT',
  'PENDING FOR APPROVAL' = 'SUBMITTED',
  'APPROVED' = 'APPROVED',
  'FREEZE' = 'FREEZE',
}

export enum RecommendedForPromotionEnum {
  YES = 'YES',
  NO = 'NO',
}

export enum UserRatingEnum {
  '1 - Low Contributor' = 'LOW_CONTRIBUTOR_1',
  '2 - Needs Improvement' = 'NEEDS_IMPROVEMENT_2',
  '3 - Meets Expectations' = 'MEETS_EXPECTATIONS_3',
  '4 - Exceeds Expectations' = 'EXCEEDS_EXPECTATIONS_4',
  '5 - Exceptional' = 'EXCEPTIONAL_5',
}

export enum StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface User {
  _id: string;
  empId: string;
  name: string;
  email: string;
  status: StatusEnum;
  department: string;
  designation: string;
  reportingManager: User;
  hod: User;
  justification: string;
  role: Role;
  promotionAnswers: QnA[];
  promotionQuestions: (QnA & { answer: QnA })[];
  reportees: User[];
  location: string;
  createdBy: User;
  band: string;
  level: number;
  annualUserInfo: AnnualUserInfo;
  updatedBy: User;
  createdAt: string;
  updatedAt: string;
}

export type AnnualUserInfo = {
  _id: string;
  period: number;
  startYearStatus: UserStatusEnum;
  midYearStatus: UserStatusEnum;
  endYearStatus: UserStatusEnum;
  isRecommendedForPromotion: RecommendedForPromotionEnum;
  overallCommentByManager: string;
  overallCommentByEmployee: string;
  year: number;
  createdAt: string;
  updatedAt: string;
};

export type QnA = {
  _id: string;
  desc: string;
  qa: QnA;
};

export type KRA = {
  _id: string;
  serialNo: string;
  kra: string;
  department: string;
  setName: string;
};

export type UserGoal = {
  _id: string;
  kra: string;
  kpi: string;
  target: string;
  weightage: number;
  empCommentMidYear: string;
  managerCommentMidYear: string;
  empCommentEndYear: string;
  managerCommentEndYear: string;
  empRatingEndYear: UserRatingEnum;
  managerRatingEndYear: UserRatingEnum;
};

export enum PeriodEnum {
  FIRST = 'FIRST',
  MID = 'MID',
  END = 'END',
}

export type Role = {
  _id: string;
  name: string;
};

export type YearSettings = {
  _id: string;
  minute: number;
  hour: number;
  goalSettingStartDay: number;
  goalSettingStartMonth: number;
  goalSettingEndDay: number;
  goalSettingEndMonth: number;
  goalSettingReminderDays: number;
  midYearStartDay: number;
  midYearStartMonth: number;
  midYearEndDay: number;
  midYearEndMonth: number;
  midYearReminderDays: number;
  endYearStartDay: number;
  endYearStartMonth: number;
  endYearEndDay: number;
  endYearEndMonth: number;
  endYearReminderDays: number;
  year: number;
};
